export default "__VITE_ASSET__a82808ea__"